<coop-offer-form
  [editMode]="false"
  [templateMode]="false"
  [formData]="formData"
></coop-offer-form>
